export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '공종명'}, {name: '대상기간'}, {name: '작성일'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputA_5
      case 2: return `${func.getContent(value).inputA_8} - ${func.getContent(value).inputA_9}`
      case 3: return func.getCreatedDate(value.created_at) // 작성일
      case 4: return func.getContent(value).stdInfo.writer_name
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value) {
      nav.dateTarget = 'content$body.inputA_8'
      nav.dateBegin = 'nav.value.inputA_8.0'
      nav.dateEnd = 'nav.value.inputA_8.1'
    }
    return {inputA_8: nav.value.inputA_8, inputA_2: nav.value.keyword }
  },
  getSearchKeyword: (nav) => {
    return ['content$body.inputA_2*[:nav.page.p83.inputA_2]']
  },
}
